// UI display for pricing page. Plan amounts/features are also in plans.config.js and featureAccess.config.js
// for backend and feature gating; keep in sync when changing prices or plan features.

// export const MARKETPLACE_PLANS = [
//     {
//       id: "basic",
//       name: "Basic",
//       theme: "light",
//       price: { monthly: 0, yearly: 0 },
//       badge: "Free",
//       features: [
//         { label: "Search 5 influencers per month", enabled: true },
//         { label: "Create 1 campaign per month", enabled: true },
//         { label: "1 team member access", enabled: true },
//         { label: "Customer Support (Email)", enabled: true },
//         { label: "Self-service Onboarding support", enabled: true },
//         { label: "DM Automation", enabled: false },
//         { label: "Influencer Contact Access", enabled: false },
//         { label: "AI Video Analysis", enabled: false },
//         { label: "AI Comment Analysis", enabled: false },
//         { label: "Fraud Detection", enabled: false },
//         { label: "Performance Reports", enabled: false }
//       ],
//       cta: "Current Plan",
//       disabled: true
//     },
//     {
//       id: "pro",
//       name: "Pro",
//       theme: "dark",
//       price: { monthly: 3000, yearly: 2100 },
//       features: [
//         { label: "Everything in Basic", enabled: true },
//         { label: "Full search", enabled: true },
//         { label: "Create 5 campaigns per month", enabled: true },
//         { label: "3 team member access", enabled: true },
//         { label: "Priority customer support", enabled: true },
//         { label: "500 DM Automation Credits", enabled: true },
//         { label: "Self-service Onboarding support", enabled: true },
//         { label: "Influencer Contact Access", enabled: true },
//         { label: "AI Video Analysis", enabled: true },
//         { label: "AI Comment Analysis", enabled: true },
//         { label: "Fraud Detection", enabled: true },
//         { label: "Performance Reports (Custom Reports)", enabled: true }
//       ],
//       cta: "Upgrade"
//     },
//     {
//       id: "pro plus",
//       name: "Pro Plus",
//       theme: "light",
//       price: { monthly: 6000, yearly: 4200 },
//       features: [
//         { label: "Everything in Pro", enabled: true },
//         { label: "Full search + Advanced Filters", enabled: true },
//         { label: "Create 10 campaigns per month", enabled: true },
//         { label: "5 team member access", enabled: true },
//         { label: "5000 DM Automation Credits", enabled: true },
//         { label: "Priority customer support", enabled: true },
//         { label: "Self-service Onboarding support", enabled: true },
//         { label: "Influencer Contact Access", enabled: true },
//         { label: "AI Video Analysis", enabled: true },
//         { label: "AI Comment Analysis", enabled: true },
//         { label: "Fraud Detection", enabled: true },
//         { label: "Performance Reports (White-label Reports)", enabled: true }
//       ],
//       cta: "Upgrade"
//     },
//     {
//       id: "premium",
//       name: "Premium",
//       theme: "light",
//       price: { monthly: 10000, yearly: 8400 },
//       features: [
//         { label: "Everything in Pro Plus", enabled: true },
//         { label: "Full search + AI Smart Match", enabled: true },
//         { label: "Create unlimited campaigns", enabled: true },
//         { label: "10 team member access", enabled: true },
//         { label: "Unlimited DM Automation Credits", enabled: true },
//         { label: "Priority customer support", enabled: true },
//         { label: "Self-service Onboarding support", enabled: true },
//         { label: "Influencer Contact Access", enabled: true },
//         { label: "AI Video Analysis", enabled: true },
//         { label: "AI Comment Analysis", enabled: true },
//         { label: "Fraud Detection", enabled: true },
//         { label: "Performance Reports (API + BI Integration)", enabled: true }
//       ],
//       cta: "Upgrade"
//     }
//   ];

/** Number of feature labels to show initially before "Show more" on the subscription page */
export const FEATURES_INITIAL_VISIBLE = 7;

export const MARKETPLACE_PLANS = [
  {
    id: "basic",
    name: "Basic",
    theme: "light",
    price: { monthly: 0, yearly: 0 },
    badge: "Free",
    features: [
      { label: "5 influencer contact unlocks / month", enabled: true },
      { label: "Create 1 active campaign", enabled: true },
      { label: "1 team member access", enabled: true },
      { label: "Customer Support (Email)", enabled: true },
      { label: "Self-serve onboarding", enabled: true },

      { label: "Influencer Contact Access", enabled: false },
      { label: "DM Automation", enabled: false },
      { label: "AI Video Analysis", enabled: false },
      { label: "AI Comment Analysis", enabled: false },
      { label: "Fraud Detection", enabled: false },
      { label: "Performance Reports", enabled: false }
    ],
    cta: "Current Plan",
    disabled: true
  },

  {
    id: "pro",
    name: "Pro",
    theme: "dark",
    price: { monthly: 999, yearly: 899 },
    badge: "Starter",
    features: [
      { label: "Everything in Basic", enabled: true },
      { label: "Full influencer marketplace search", enabled: true },
      { label: "25 influencer contact unlocks / month", enabled: true },
      { label: "Create 5 active campaigns", enabled: true },
      { label: "3 team member access", enabled: true },
      { label: "500 DM Automation / month", enabled: true },
      // { label: "AI Video Analysis (10 videos / month)", enabled: true },
      // { label: "AI Comment Analysis (Basic Sentiment)", enabled: true },
      { label: "Fraud Detection (Basic)", enabled: true },
      { label: "Performance Reports (Custom Reports)", enabled: true },
      { label: "Priority Email Support", enabled: true }
    ],
    cta: "Upgrade"
  },

  {
    id: "pro_plus",
    name: "Pro Plus",
    theme: "light",
    price: { monthly: 2999, yearly: 2699 },
    badge: "Most Popular",
    features: [
      { label: "Everything in Pro", enabled: true },
      { label: "Full search + Advanced Filters", enabled: true },
      { label: "200 influencer contact unlocks / month", enabled: true },
      { label: "Create 20 active campaigns", enabled: true },
      { label: "10 team member access", enabled: true },
      { label: "5,000 DM Automation / month", enabled: true },
      { label: "AI Video & Comment Analysis (100 videos / month)", enabled: true },
      { label: "Fraud Detection (Advanced)", enabled: true },
      { label: "Performance Reports (White-label Reports)", enabled: true },
      { label: "Chat + Priority Support", enabled: true }
    ],
    cta: "Upgrade"
  },

  // {
  //   id: "premium",
  //   name: "Premium",
  //   theme: "light",
  //   price: { monthly: 10000, yearly: 8400 },
  //   badge: "Enterprise",
  //   features: [
  //     { label: "Everything in Pro Plus", enabled: true },
  //     { label: "Full search + AI Smart Match", enabled: true },
  //     { label: "Unlimited influencer contact unlocks", enabled: true },
  //     { label: "Unlimited campaigns", enabled: true },
  //     { label: "Unlimited team members", enabled: true },
  //     { label: "Unlimited DM Automation + AI reply suggestions", enabled: true },
  //     { label: "AI Video Analysis (Unlimited + Deep Insights)", enabled: true },
  //     { label: "AI Comment Analysis (Buyer Intent + Fraud Detection)", enabled: true },
  //     { label: "AI Predictive Fraud Scoring", enabled: true },
  //     { label: "Performance Reports (API + BI Integration)", enabled: true },
  //     { label: "Dedicated Account Manager", enabled: true }
  //   ],
  //   cta: "Upgrade"
  // }
];

// 👉 Tomorrow you can create:

// COMPANY_PLANS
// AGENCY_PLANS
// ENTERPRISE_PLANS